import { agingStatus } from "./agingStatus";

export function customerAlias({ name, alias, active, reason, tag }: { name: string, alias: string, active: boolean, reason: string, tag: string }, showDisabledStatus: boolean = true): string {
  let customerAlias = alias ?  alias : name;
  if(active == undefined) return customerAlias;
  const agingStatusStr = agingStatus({ active, reason, tag });
  if(agingStatusStr != 'Active' && showDisabledStatus) {
    customerAlias = `${customerAlias} (${agingStatusStr})`;
  }
  return customerAlias;
}